import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component({
  template: `
<div class="page-container">
  <div class="form-container" :class="{ 'centered': centered }">
    <template v-if="centered">
    <div class="content-centered">
      <div class="content-box">
        <slot></slot>
      </div>
    </div>
    </template>
    <template v-else><slot></slot></template>
  </div>
</div>
`
})
export class RegistrationPageComponent extends Vue {

  @Prop()
  centered: boolean;

}

Vue.component('registration-page', RegistrationPageComponent);



// WEBPACK FOOTER //
// ./src/components/registation-page/registration-page.ts